import React from 'react';
import { useNavigate } from 'react-router-dom';
import ParentContainor from '../../components/base/ParentContainor';
import LeaderboardScreen from '../../components/LeaderboardScreen';
import { ROUTE_ENUM } from '../../routes/RoutesConstant';
import { TEXT_LABELS } from '../../constants/TextLabelConstants';
import { PAGE_OUTER_PADDING } from '../../constants/housieLiveStyles';
import { IMAGE_CONSTANTS } from '../../constants/ImageConstans';

/**
 * TEMP preview page — mock leaderboard design (no auth / no API).
 * Open: /preview/leaderboard
 * Remove when design review is done.
 */
const MOCK_PLAYERS = [
  {
    userId: 'p1',
    username: 'Player B',
    points: 200000,
    avatar: IMAGE_CONSTANTS.V2_IMAGE_PLACEHOLDER,
    win: { rapCoin: 2000 },
  },
  {
    userId: 'p2',
    username: 'Player A',
    points: 150000,
    avatar: IMAGE_CONSTANTS.V2_IMAGE_PLACEHOLDER,
    win: { rapCoin: 1500 },
  },
  {
    userId: 'p3',
    username: 'Player C',
    points: 120000,
    avatar: IMAGE_CONSTANTS.V2_HEADER_LOGO || IMAGE_CONSTANTS.V2_IMAGE_PLACEHOLDER,
    win: { rapCoin: 1200 },
  },
  {
    userId: 'p4',
    username: 'Rubby Jain',
    points: 50000,
    avatar: IMAGE_CONSTANTS.V2_IMAGE_PLACEHOLDER,
    win: { rapCoin: 500 },
  },
  {
    userId: 'p5',
    username: 'QuizWarrior',
    points: 42000,
    avatar: IMAGE_CONSTANTS.V2_IMAGE_PLACEHOLDER,
    win: { rapCoin: 420 },
  },
  {
    userId: 'p6',
    username: 'RapStar99',
    points: 38000,
    avatar: IMAGE_CONSTANTS.V2_IMAGE_PLACEHOLDER,
    win: { rapCoin: 380 },
  },
  {
    userId: 'p7',
    username: 'NeonNinja',
    points: 31000,
    avatar: IMAGE_CONSTANTS.V2_IMAGE_PLACEHOLDER,
    win: { rapCoin: 310 },
  },
  {
    userId: 'p8',
    username: 'LuckySeven',
    points: 25000,
    avatar: IMAGE_CONSTANTS.V2_IMAGE_PLACEHOLDER,
    win: { rapCoin: 250 },
  },
];

const LeaderboardDesignPreview = () => {
  const navigate = useNavigate();

  return (
    <ParentContainor
      route={ROUTE_ENUM.SELECT_GAME}
      parentContainorStyle={{ justifyContent: 'flex-start' }}
      isShowHeader={false}
      showCopyRightText
      isBreadcrumbVisible={false}
      padding={PAGE_OUTER_PADDING}
      showBlurredBg
    >
      <LeaderboardScreen
        headerTitle="Fun Friday eve. - Leaderboard"
        onBack={() => navigate(ROUTE_ENUM.SELECT_GAME.routePath)}
        columns={{
          rank: TEXT_LABELS.RAP_HOUSIE_LEADERBOARD_COL_RANK,
          player: TEXT_LABELS.RAP_HOUSIE_LEADERBOARD_COL_PLAYER,
          points: TEXT_LABELS.RAP_HOUSIE_LEADERBOARD_COL_GAME_POINTS,
          won: TEXT_LABELS.RAP_HOUSIE_LEADERBOARD_COL_WON,
        }}
        players={MOCK_PLAYERS}
        showBoard
        emptyLabel={TEXT_LABELS.RAP_HOUSIE_LEADERBOARD_NO_WINNERS}
        congratsLabel={TEXT_LABELS.RAP_HOUSIE_LEADERBOARD_SUBTITLE}
      />
    </ParentContainor>
  );
};

export default LeaderboardDesignPreview;
